import { render } from "./NovedadesAjustesCH.vue?vue&type=template&id=093d6006"
import script from "./NovedadesAjustesCH.vue?vue&type=script&lang=js"
export * from "./NovedadesAjustesCH.vue?vue&type=script&lang=js"

import "./NovedadesAjustesCH.vue?vue&type=style&index=0&id=093d6006&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__